// Third-party
import React from 'react';

// Components
import { SelectInput, SelectOption } from '@/views/components/inputs';
import Locale from '@/types/locale';
import { Typography } from '@capintel/component-lib/typography';

// Utils
import { formatMessage, FormattedMessage, getLang, LOCALE } from '@/utils/i18n';
import { ALLOWED_HTML_TAGS } from '@/views/components/i18n/FormattedMessageV2';

type Props = {
  onLocaleChange?: (locale: Locale) => void;
  selectedLocale: Locale;
  appLocales: Locale[];
};

const ProposalLanguageSelector: React.FunctionComponent<Props> = ({ onLocaleChange, selectedLocale, appLocales }: Props) => {
  const label = formatMessage('Proposal.Tabs.Options.Language.Label');
  const availableLocales = Object.values(LOCALE).filter(locale => appLocales.includes(locale));

  return (
    <div className="proposal-option">
      <Typography as={ALLOWED_HTML_TAGS.H2} variant="headerXs">
        <FormattedMessage id="Proposal.Tabs.Options.Language.Title" />
      </Typography>

      <SelectInput placeholder="---" onValueChange={onLocaleChange} key={selectedLocale} selected={selectedLocale} compact aria-label={label}>
        {availableLocales.map(locale => {
          const optionText = formatMessage(`Proposal.Tabs.Options.Language.${locale}`);
          return (
            <SelectOption key={locale} value={locale} lang={locale}>
              {optionText}
            </SelectOption>
          );
        })}
      </SelectInput>
    </div>
  );
};

export default ProposalLanguageSelector;
